import _Vue from "vue";
import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
import isBetween from "dayjs/plugin/isBetween";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import weekOfYear from "dayjs/plugin/weekOfYear";
import weekday from "dayjs/plugin/weekday";
import duration from "dayjs/plugin/duration";
import localizedFormat from "dayjs/plugin/localizedFormat";

dayjs.extend(relativeTime);
dayjs.extend(isBetween);
dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(weekOfYear);
dayjs.extend(weekday);
dayjs.extend(duration);
dayjs.extend(localizedFormat);

export function setDefaultTimezone(tz: string): void {
  dayjs.tz.setDefault(tz);
}

export function loadDayjsLocale(locale: string): void {
  const lowercaseLocale = locale.toLowerCase();
  // TODO
}

/**
 * Represents a date converted to the application timezone. Returns a Day.js object converted
 * to the application timezone, without the timezone from the tz plugin.
 *
 * To fix issues with the tz plugin when working with isBefore/isAfter, for example.
 */
export function getTimeWithoutTimezone(date?: dayjs.ConfigType | undefined) {
  return dayjs(dayjs(date).tz().format("YYYY-MM-DDTHH:mm:ss"));
}

export function DayJsPlugin(Vue: typeof _Vue, options?: any): void {
  Vue.prototype.$dayjs = dayjs;
}
